import { Pipe, PipeTransform } from '@angular/core';
import { filesize } from 'filesize';

@Pipe({
    name: 'filesize',
})
export class FileSizePipe implements PipeTransform {
    public transform(value: number, options?: { round?: number }): string {
        const oneMegaByte = 1_000_000;
        const roundTwo = 2;

        return filesize(
            value,
            options ?? {
                round: value < oneMegaByte ? 0 : roundTwo,
            },
        );
    }
}
